export function withPolling(pollingFunction: () => Promise<void>, interval: number = 5000): () => void {
  let alreadyLoading = false;
  let shouldBreak = false;

  // Using recursive calls instead of setInterval to prevent issues with long running tasks
  async function asyncInterval(asyncFunction: () => Promise<void>, timeout: number): Promise<void> {
    if (shouldBreak) {
      return;
    }

    if (alreadyLoading) {
      // Check again after timeout
      setTimeout(() => {
        void asyncInterval(asyncFunction, timeout);
      }, timeout);
    }

    try {
      alreadyLoading = true;
      await asyncFunction();
    } finally {
      alreadyLoading = false;
      setTimeout(() => {
        void asyncInterval(asyncFunction, timeout);
      }, timeout);
    }
  }

  void asyncInterval(async () => {
    await pollingFunction();
  }, interval);

  return (): void => {
    shouldBreak = true;
  };
}
